module.exports = __webpack_public_path__ + "img/EMT-PDAC_GSE202740.2e8d012a.png";